import React, {FC} from "react"
import {MarkdownAtom, MarkdownBlock} from "../../model/markdown/MarkdownText"
import {AtomsViewer} from "../atoms/AtomsViewer"
import {getIdentStyle, getSubLists} from "./MarkdownOrderedList"
import './MarkdownUnorderedList.less'

interface MarkdownUnorderedListProps {
    block: MarkdownBlock
    onToggleCheckBox: (atom: MarkdownAtom) => void
}

export const MarkdownUnorderedList: FC<MarkdownUnorderedListProps> = ({
                                                                          block,
                                                                          onToggleCheckBox
                                                                      }) => {
    const subLists: Array<MarkdownBlock> = getSubLists(block)

    return (
        <>
            {subLists.map((subList) => (
                <div className="block unorderedList" key={subList.id}>
                    <ul>
                        {subList.atoms.map(atom => (
                            <li key={atom.id} style={getIdentStyle(atom.indent)}>
                                <AtomsViewer atoms={atom.subAtoms} onToggleCheckBox={onToggleCheckBox}/>
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </>
    )
}
